import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

export const customerTransitAuthSchema = z.object({
  transitAuthorisations: z.array(
    z.object({
      type: z.string().optional().nullable(),
      referenceNumber: z.string().optional().nullable(),
      limitDateDays: z.number().optional().nullable(),
    }),
  ),
});
export type CustomerViewTransitAuthFormValues = z.infer<typeof customerTransitAuthSchema>;

export const useCustomerViewTransitAuthFormInitializer = ({ customerDetails }) => {
  const buildFormValues = (cd) => ({
    transitAuthorisations: (cd?.transitAuthorisations || []).map((transitAuthorisation) => ({
      type: transitAuthorisation.type,
      referenceNumber: transitAuthorisation.referenceNumber,
      ...(transitAuthorisation.type === 'C521' && { limitDateDays: transitAuthorisation.limitDateDays }),
    })),
  });

  const form = useForm<CustomerViewTransitAuthFormValues>({
    initialValues: buildFormValues(customerDetails),
    validate: zodResolver(customerTransitAuthSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
